export default {
  bind (el) {
    const header = el.querySelector('.el-dialog__header')
    const dialog = el.querySelector('.el-dialog')

    if (!header || !dialog) return

    header.style.cursor = 'move'
    header.style.userSelect = 'none'

    header.onmousedown = (e) => {
      const rect = dialog.getBoundingClientRect()
      const offsetX = e.clientX - rect.left
      const offsetY = e.clientY - rect.top

      const moveHandler = (e) => {
        let left = e.clientX - offsetX
        let top = e.clientY - offsetY

        const maxLeft = window.innerWidth - dialog.offsetWidth
        const maxTop = window.innerHeight - dialog.offsetHeight

        left = Math.max(0, Math.min(left, maxLeft))
        top = Math.max(0, Math.min(top, maxTop))

        dialog.style.left = left + 'px'
        dialog.style.top = top + 'px'
        dialog.style.margin = '0'
        dialog.style.transform = 'none'
      }

      const upHandler = () => {
        document.removeEventListener('mousemove', moveHandler)
        document.removeEventListener('mouseup', upHandler)
      }

      document.addEventListener('mousemove', moveHandler)
      document.addEventListener('mouseup', upHandler)
    }
  }
}